import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHotkeys } from 'react-hotkeys-hook'
import { BARS_BY_LINE, ROMAN_DEGREES } from '../util/constants'
import { addTts, compareTts, findIndexInRanges, getRange, getTtAndLineIndexFromXY, getTtFromX2, isIndexInRanges, ttRangesCross } from '../util/utils'
import BackingTrackSection from './BackingTrackSection'
import EditorChordCard from './EditorChordCard'
import { EditorActionType } from './editorStore/backingTrackGeneratorEditorActions'
// import BackingTrackGeneratorSectionsContext from './sectionsStore/BackingTrackGeneratorSectionsContext'
import BackingTrackGeneratorEditorContext from './editorStore/BackingTrackGeneratorEditorContext'
import { Chord as ChordType } from './editorStore/backingTrackGeneratorEditorState'
import Chord from '@tonaljs/chord'
import { getScaleChords } from '../util/TonalUtils'


let isPostInit = false
setTimeout(() => isPostInit = true, 1000)

const getEditorChordCards = (chord: ChordType, chordIndex: number, chordSelectRanges: [number, number][], handleSectionMouseMove: (e: any) => void, currLinesDrag?: number[]): readonly JSX.Element[] => {

	const isSelect = isIndexInRanges(chordIndex, chordSelectRanges)

	const indexInRanges = findIndexInRanges(chordSelectRanges, chordIndex)

	// Get all lines until chord range isInBetween
	const lineRanges: [string, string][] = [['0:0', BARS_BY_LINE + ':0']]
	let currTt = BARS_BY_LINE + ':0'

	while (compareTts(addTts(lineRanges[lineRanges.length - 1][0], lineRanges[lineRanges.length - 1][1]),
		addTts(chord.transportTime, chord.transportTimeDuration)) === 1) {
		lineRanges.push([currTt, BARS_BY_LINE + ':0'])
		currTt = addTts(currTt, BARS_BY_LINE + ':0')
	}

	// @ts-ignore
	return lineRanges.map((lineRange: [string, string], lineIndex: number) => {
		
		// r2		[--] -> 1			[--] -> -1		[--]	-> 0		[------]	-> 2		-> undefined
		// r1	[--]							[--]			[------]					[--]
		const cross = ttRangesCross(getRange(chord), lineRange)

		const shouldntBeRerender = currLinesDrag && indexInRanges !== -1 && currLinesDrag[indexInRanges] === lineIndex

		const key = chord.id + (cross === 2 ? '' : shouldntBeRerender ? '' : '-' + lineIndex)
		// const key = chord.id + (cross === 2 ? '' : currLineDrag && (lineIndex === currLineDrag) ? '' : '-' + lineIndex)
		
		return cross !== undefined ? (
			<EditorChordCard
				key={key}
				chordIndex={chordIndex}
				// onPlayClick={onPlayClick}
				isPostInit={isPostInit}
				lineIndex={lineIndex}
				cross={cross}
				onMouseMove={handleSectionMouseMove}
			/>
		) : undefined
	}).filter((el: JSX.Element | undefined) => el !== undefined)
}

const BackingTrackEditor = (props: {
	onPlayClick: (chord: any) => void,
	timeSignature: any
}) => {

	const {
		timeSignature
	} = props

	// console.log({ editor })
	// const [sections] = useContext(BackingTrackGeneratorSectionsContext)

	const [editor, dispatchEditor] = useContext(BackingTrackGeneratorEditorContext)

	const [degreesChords, setDegreesChords] = useState(getScaleChords(editor.config.scale))
	
	useEffect(() => {
		setDegreesChords(getScaleChords(editor.config.scale))
	}, [editor.config.scale])


	// console.log({ BackingTrackEditor: editor })
	
	// Chords Move / Expand

	useHotkeys('left', (e: any, handler) => {
		e.preventDefault()// Otherwise move page scrollX
		console.log({ ranges: editor.state.chordSelectedRanges })
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectPrev
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorMovePrevBeat
			})
	}, [editor.state])
	useHotkeys('right', (e: any) => {
		e.preventDefault()
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectNext,
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorMoveNextBeat
			})
	}, [editor.state])

	useHotkeys('ctrl+left', (e: any) => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectMovePrevBeat
			})
	}, [editor.state])
	useHotkeys('ctrl+right', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectMoveNextBeat
			})
	}, [editor.state])

	useHotkeys('ctrl+alt+left', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectMovePrev16th
			})
	}, [editor.state])
	useHotkeys('ctrl+alt+right', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectMoveNext16th
			})
	}, [editor.state])

	useHotkeys('ctrl+shift+left', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectMovePrevBar
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorExpandLeftBar
			})
	}, [editor.state])
	useHotkeys('ctrl+shift+right', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectMoveNextBar
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorExpandRightBar
			})
	}, [editor.state])

	// Chords Others

	useHotkeys('ctrl+a', () => {
		dispatchEditor({
			type: EditorActionType.ChordSelectGroup,
		})
	}, [editor.state])


	useHotkeys('shift+left', () => {// TODO : go from cursors to chord selections
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectExpandLeft
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorExpandLeftBeat
			})
	}, [editor.state])
	useHotkeys('shift+right', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectExpandRight,
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorExpandRightBeat
			})
	}, [editor.state])

	// Cursors Move

	useHotkeys('alt+left', (e: any) => {
		e.preventDefault()// Otherwise go prev page
		if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorMovePrev16th
			})
	}, [editor.state])
	useHotkeys('alt+right', (e: any) => {
		e.preventDefault()
		if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorMoveNext16th
			})
	}, [editor.state])

	useHotkeys('ctrl+left', () => {
		if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorMovePrevBar
			})
	}, [editor.state])
	useHotkeys('ctrl+right', () => {
		if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorMoveNextBar
			})
	}, [editor.state])

	// Cursors Expand

	useHotkeys('shift+alt+left', (e: any) => {
		e.preventDefault()
		e.stopPropagation()
		if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorExpandLeft16th
			})
	}, [editor.state])
	useHotkeys('shift+alt+right', (e: any) => {
		e.preventDefault()
		e.stopPropagation()
		if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorExpandRight16th
			})
	}, [editor.state])

	// Cursors Other

	useHotkeys('backspace, del, delete', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordSelectDelete
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorDelete
			})
	}, [editor.state])

	useHotkeys('enter', () => {
		if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorToChordSelect
			})
	}, [editor.state])

	// Others

	useHotkeys('esc', () => {
		if (editor.state.chordSelectedRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.ChordUnselect
			})
		else if (editor.state.cursorRanges.length > 0)
			dispatchEditor({
				type: EditorActionType.CursorUnselect
			})
	}, [editor.state])

	// Add Chord
	
	for (let i = 0; i < 7; i++) {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		useHotkeys((i + 1) + ',*', (e: any, handler: any) => {
			if (handler.shortcut === '*' && (e.code !== 'Numpad' + (i + 1) || e.key !== (i + 1).toString())) return

			const chord = degreesChords[i]

			if (editor.state.chordSelectedRanges.length > 0)
				dispatchEditor({
					type: EditorActionType.ChordChange,
					payload: {
						chord
					}
				})
			else// else add chords
				dispatchEditor({
					type: EditorActionType.ChordAdd,
					payload: {
						chord
					}
				})
		}, [editor.state])
	}

	useHotkeys('up', (e: any, handler: any) => {
		if (editor.state.chordSelectedRanges.length > 0) {
			e.preventDefault()
			dispatchEditor({
				type: EditorActionType.ChordDegreeUp
			})
		}
	}, [editor.state])
	useHotkeys('down', (e: any, handler: any) => {
		if (editor.state.chordSelectedRanges.length > 0) {
			e.preventDefault()
			dispatchEditor({
				type: EditorActionType.ChordDegreeDown
			})
		}
	}, [editor.state])

	const [dragTt, setDragTt] = useState<string | undefined>(undefined)

	const containerEl = useRef<any>(undefined)

	const handleSectionClick = (e: any) => {
		// e.stopPropagation()


		if (editor.state.initialCursorDragTt !== undefined) {
		// if (startDragIndex !== undefined) {
			// setStartDragIndex(undefined)
			setDragTt(undefined)
			return
		}

		console.log({ e: e })

		const x = e.pageX - containerEl.current.offsetLeft
		const y = e.pageY - containerEl.current.offsetTop

		// Might needs an update, use getTtFromXY
		// const transportTime = getTtFromX2(x, editor.sections, lineIndex, sectionIndex)
		const { tt, globalLineIndex } = getTtAndLineIndexFromXY(x, y, editor.sections, dragTt)

		dispatchEditor({
			type: EditorActionType.CursorMove,
			payload: {
				transportTime: tt
			}
		})
	}

	const handleSectionMouseDown = (e: any) => {
		// e.stopPropagation()

		const x = e.pageX - containerEl.current.offsetLeft
		const y = e.pageY - containerEl.current.offsetTop

		// Might needs an update, use getTtFromXY
		// const transportTime = getTtFromX2(x, editor.sections, lineIndex, sectionIndex)
		const { tt, globalLineIndex } = getTtAndLineIndexFromXY(x, y, editor.sections, dragTt)

		// setStartDragIndex(lineIndex)
		setDragTt(tt)

		dispatchEditor({
			type: EditorActionType.CursorDragStart,
			payload: {
				transportTime: tt
			}
		})
	}

	// const handleSectionMouseMove = (e: any, lineIndex: number, sectionIndex: number) => {
	const handleSectionMouseMove = (e: any) => {
		if (editor.state.initialCursorDragTt === undefined) return

		e.stopPropagation()

		const x = e.pageX - containerEl.current.offsetLeft
		const y = e.pageY - containerEl.current.offsetTop

		// Might needs an update, use getTtFromXY
		// const transportTime = getTtFromX2(x, editor.sections, lineIndex, sectionIndex)

		const { tt, globalLineIndex } = getTtAndLineIndexFromXY(x, y, editor.sections, dragTt)

		
		if (tt !== dragTt) {
			setDragTt(tt)

			dispatchEditor({
				type: EditorActionType.CursorDrag,
				payload: {
					transportTime: tt
				}
			})
		}
	}

	const handleSectionContainerClick = (e: any) => {

		console.log('handleSectionContainerClick')
		
		if (editor.state.initialCursorDragTt === undefined) return
		e.stopPropagation()
		// setStartDragIndex(undefined)
		setDragTt(undefined)
		dispatchEditor({
			type: EditorActionType.CursorDragEnd
		})
	}

	const chords = (editor.fakeChords || editor.chords)
	
	// const sectionsChordsLines = editor.sections.map((section: Section) =>
	// 	Array.from(Array(Math.ceil(parseInt(section.transportTimeDuration.split(':')[0]) / BARS_BY_LINE))).map((_, i: number) =>
	// 		getChordsInRange(chords, [substractTts(addTts(section.transportTime, (i * BARS_BY_LINE) + ':0'), '1:0'), addTts(BARS_BY_LINE + ':0', '2:0')])))

	/* zIndexes
	 	line: 1
			range: 2
	 			bar: 3
	 				chord: 4
						dragChord: 5
	 						cursor: 6
								suggestions: 7 // TODO : still going under chard which has zIndex = 4
	*/

	// get width of text in pixel

	return (
		<div
			id='backing-track-editor'
			style={{ display: 'flex', justifyContent: 'center' }}
		>

			{/* {editor.state.chordSelectedRanges.length > 0 && (editor.state.chordSelectedRanges[0][0] + '-' + editor.state.chordSelectedRanges[0][1])}
			{editor.fakeChords && 'drag'} */}
			
			<div
				ref={containerEl}
				style={{ display: 'flex', flexDirection: 'column', position: 'relative', overflow: 'hidden' }}
				onClick={handleSectionContainerClick}
			>

				{editor.sections.map((section: any, sectionIndex: number) => (
					<BackingTrackSection
						sectionIndex={sectionIndex}
						timeSignature={sectionIndex === 0 ? timeSignature : undefined}
						onPlayClick={() => null}
						onMouseDown={(e: any, lineIndex: number) => handleSectionMouseDown(e)}
						onMouseMove={(e: any, lineIndex: number) => handleSectionMouseMove(e)}
						onClick={(e: any, lineIndex: number) => handleSectionClick(e)}
					/>
				))}

				
				{chords.flatMap((chord: ChordType, chordIndex: number) => (
					// getEditorChordCards(chord, chordIndex, editor.state.chordSelectedRanges, editor.state.currChordSelectDragLineIndex)
					getEditorChordCards(chord, chordIndex, editor.state.chordSelectedRanges, handleSectionMouseMove, editor.state.currChordsSelectDragLineIndexes)
				))}

				{/* {sectionsChordsLines.map((chordsLines: any, sectionIndex: number) =>
					chordsLines.map((chordsLine: any, lineIndex: number) => (
						chordsLine.map((chord: Chord, chordIndex: number) => (
							<EditorChordCard
								key={chord.id}
								chordIndex={chords.findIndex((c: any) => c.id === chord.id)}
								// onPlayClick={onPlayClick}
								lineIndex={lineIndex}
								sectionIndex={sectionIndex}
								isPostInit={isPostInit}
								// first={timeSignature && i === 0 && j === 0}
							/>
						))
					))
				)} */}

			</div>
		</div>
	)
}

export default BackingTrackEditor

// DONE : handle tab